/**
 * @generated SignedSource<<640541e03c06bcd079411c83faee7744>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateWidgetTaskCollectionInput = {
  positionX: number;
  positionY: number;
  tasks: ReadonlyArray<CreateWidgetTaskCollectionInputTask>;
  title: string;
};
export type CreateWidgetTaskCollectionInputTask = {
  sectionId: string;
  taskId: string;
};
export type WATaskCollectionMutation$variables = {
  input: CreateWidgetTaskCollectionInput;
  storecastId: string;
};
export type WATaskCollectionMutation$data = {
  readonly dashboard: {
    readonly createWidgetTaskCollection: {
      readonly id: string;
    };
  };
};
export type WATaskCollectionMutation = {
  response: WATaskCollectionMutation$data;
  variables: WATaskCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTaskCollection",
        "kind": "LinkedField",
        "name": "createWidgetTaskCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATaskCollectionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WATaskCollectionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "60007e1ae95f5ce76a39871e5148099d",
    "id": null,
    "metadata": {},
    "name": "WATaskCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation WATaskCollectionMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTaskCollectionInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTaskCollection(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e4d8b1f51e183cfc9f924d2ac282f99";

export default node;
